const formatting = __litium.priceFormatting;
export function customFormatNumber(number) {
    number = (Math.round(number * 100) / 100).toFixed(formatting.decimals);
    let thousandSeparator = formatting.thousandGroupSeparator || '';
    let decimalSeparator = formatting.decimalSeparator;
    let parts = number.toString().split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousandSeparator);
    return parts.join(decimalSeparator);
}
/**
 * @returns {string}
 * @constructor
 */
Number.prototype.formatPrice = function () {
    let formattedPrice = customFormatNumber(this);
    switch (formatting.position) {
        case 'Left':
            return `${formatting.currencySymbol}${formattedPrice}`;
        case 'LeftWithPadding':
            return `${formatting.currencySymbol} ${formattedPrice}`;
        case 'Right':
            return `${formattedPrice}${formatting.currencySymbol}`;
        case 'RightWithPadding':
            return `${formattedPrice} ${formatting.currencySymbol}`;
    }
};
